<div [ngClass]="{ 'object-container': true, 'object-selected': object.isSelected }">
  <app-comment-panel
    (click)="expandSelected($event)"
    referenceType="OBJECT"
    [referenceId]="object.id"
    [referenceName]="object.objectNumber"
  >
    <div class="object" [ngStyle]="{ 'padding-left.px': getIndentation(), 'padding-right.px': 39 }">
      <div class="object-details object-border">
        <div class="object-title-area">
          <div class="object-title-text">
            <div [ngClass]="getObjectNumberClass()">
              {{ object.objectNumber }}
            </div>
            @if (object.cable?.fromTagNo || object.cable?.fromTagName || object.cable?.fromTagArea) {
              <div class="object-cable-line">
                From: {{ object.cable?.fromTagNo }} - {{ object.cable?.fromTagName }} ({{ object.cable?.fromTagArea }})
              </div>
            }
            @if (object.cable?.toTagNo || object.cable?.toTagName || object.cable?.toTagArea) {
              <div class="object-cable-line">
                To: {{ object.cable?.toTagNo }} - {{ object.cable?.toTagName }} ({{ object.cable?.toTagArea }})
              </div>
            }
          </div>
          <div class="object-checklist-link">
            @if (shouldShowCompletionLink()) {
              <a
                target="_blank"
                rel="noopener noreferrer"
                [attr.href]="completionLink"
                (click)="$event.stopPropagation()"
              >
                <span>{{ completionSystemName }}</span>
                <em class="material-icons icon">link</em>
              </a>
            }
          </div>
        </div>
        <div class="object-progress">
          <div [ngStyle]="{ 'padding-left.px': indentationPerStep * level }">
            @if (level === 0) {
              <app-progress-indicator
                value="{{ object.getProgress() }}"
                color="{{ object.isSelected ? 'SECONDARY' : 'PRIMARY' }}"
              ></app-progress-indicator>
            } @else {
              {{ getProgressLabel(object.getProgress()) }}
            }
          </div>
        </div>
        <div class="object-select">
          <mat-checkbox
            class="mat-checkbox-xl"
            [checked]="object.isSelected"
            (change)="toggleSelected()"
            (click)="$event.stopPropagation()"
          ></mat-checkbox>
        </div>
        <div class="object-expand">
          <button (click)="expandSelected($event)">
            <em class="material-icons icon">
              {{ object.expandChildren ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </em>
          </button>
        </div>
      </div>
    </div>
  </app-comment-panel>

  @if (object.expandChildren) {
    <div>
      @if (getVisibleWorkLines().length > 0) {
        @for (workLine of getVisibleWorkLines(); track workLine.id ?? workLine) {
          <app-comment-panel
            [id]="workLine.id"
            referenceType="WORK_LINE"
            [referenceId]="workLine.id"
            [referenceName]="workLine.name"
          >
            <app-work-line [workLine]="workLine"></app-work-line>
          </app-comment-panel>
        }
      }
      @for (childObject of getVisibleChildren(); track childObject.id ?? childObject) {
        <div>
          <app-object
            [workOrder]="workOrder"
            [parent]="object"
            [object]="childObject"
            [level]="level + 1"
            [statusCodes]="statusCodes"
            [objectList]="object.children"
            [filters]="filters"
          ></app-object>
        </div>
      }
    </div>
  }
</div>
